export default __webpack_public_path__ + "static/media/saucer_spin.e97fa435.svg";